import { Post } from "domain/infra/data/api";
import AuthConstants from "../../infra/data/authConstants"
import { UsuarioResponse } from "domain/types/usuario/usuarioResponse";
export class AuthService {// extends ExemploService {
  constructor() {
    //super()
  }

  async Login(request: FormData): Promise<UsuarioResponse | Error> {
    return await Post(AuthConstants.apiAuth.auth.login, request)
  }
}
